import { css } from "@emotion/react";
import { ThemedCssCreator } from "../../../../config/emotion";
// eslint-disable-next-line
export const pagingButtonCss: ThemedCssCreator = ({ colors }) => css`
  background-color: ${colors.secondaryColor};
  min-width: 24px;
  height: 24px;
  margin-right: 3px;
  box-shadow: 2px 1px 2px rgb(189, 189, 189);
`;
